const state = {
  sedes: [],
  ultimaSede: null
}

export default state
